/* Dropdayz — laadstreep tussen pagina's. 19 aug 2026, keuze 2B.

   HET PROBLEEM
   Je klikt op een sneaker en dan is er een halve seconde niets: de oude
   pagina staat er nog, er beweegt niks, en pas daarna komt de nieuwe. Op een
   telefoon voelt dat gat het langst en denken mensen dat hun tik niet is
   aangekomen — waarna ze nog eens tikken.

   WAT DIT DOET
   Een streep van 3 px in Dropdayz-blauw loopt bovenaan het scherm vol zodra
   je op een interne link klikt. Hij schiet in 0,4 s naar 70% en kruipt daarna
   langzaam richting 90%: dat is de eerlijke manier om te zeggen "er gebeurt
   iets, en het duurt nog even". Vol wordt hij nooit vanzelf — de nieuwe
   pagina neemt het over.

   WAAROM GEEN OVERGANG OVER DE HELE PAGINA
   Er was ook een variant met een winkelrolluik. Mooier, maar hij duurde ruim
   een seconde en die zie je bij het doorbladeren van twintig paren twintig
   keer. Een animatie die je vaker ziet dan dat je hem opmerkt moet klein
   zijn. Deze merk je alleen als hij er níet is.

   WAT ER BEWUST NÍET GEBEURT
   De pagina wordt niet gedimd en er komt geen overlay. Dat leek in de mockup
   leuk, maar het maakt een snelle klik juist tráger aanvoelend: je ziet een
   flits van grijs waar je niet om vroeg. Alleen de streep dus.

   TECHNISCH
   - Alleen transform-vrije width-transitie op één absoluut geplaatst element.
     Geen layout-herberekening van de pagina, geen extra bestand in de head.
   - Alleen interne links, linkermuisknop, zonder ctrl/cmd/shift (want dan
     opent de bezoeker een nieuw tabblad en blijft deze pagina staan).
   - Overslaan bij download, target=_blank, mailto:, tel:, #anker en bij
     elk element met data-ddz-geen-streep.
   - Terug-knop: de browser haalt de pagina uit zijn cache en toont hem
     inclusief de halve streep. Daarom wist pageshow hem.
   - Blijft de navigatie uit (bijvoorbeeld omdat een ander script hem
     tegenhoudt), dan verdwijnt de streep na 8 seconden vanzelf.
   - Andere scripts kunnen hem starten met window.ddzLaadstreep.start(),
     bijvoorbeeld de maatbalk die met location.href navigeert.
   - Bij "verminder beweging" in de systeeminstellingen gebeurt er niets. */
(function(){
  'use strict';
  if(window.ddzLaadstreep) return;

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var streep = null;
  var timer = null;
  var kruip = null;

  function maak(){
    if(streep) return streep;
    var s = document.createElement('div');
    s.id = 'ddz-laadstreep';
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText =
      'position:fixed;left:0;top:0;height:3px;width:0;z-index:2147483000;' +
      'background:#30a8e0;box-shadow:0 0 8px rgba(48,168,224,.6);' +
      'opacity:0;pointer-events:none;' +
      'transition:width .4s cubic-bezier(.2,.8,.3,1),opacity .25s ease;';
    document.body.appendChild(s);
    streep = s;
    return s;
  }

  function start(){
    if(rustig) return;
    var s = maak();
    stop(true);
    s.style.transition = 'none';
    s.style.width = '0';
    s.style.opacity = '1';
    /* forceer een herberekening, anders slaat de browser de sprong over */
    void s.offsetWidth;
    s.style.transition = 'width .4s cubic-bezier(.2,.8,.3,1),opacity .25s ease';
    s.style.width = '70%';

    /* daarna langzaam richting 90 procent kruipen */
    var breedte = 70;
    kruip = setInterval(function(){
      breedte += (90 - breedte) * 0.12;
      s.style.transition = 'width .35s linear,opacity .25s ease';
      s.style.width = breedte.toFixed(1) + '%';
    }, 350);

    /* vangnet: navigeert er toch niets, dan gaat hij weer weg */
    timer = setTimeout(function(){ stop(); }, 8000);
  }

  function stop(stil){
    if(kruip){ clearInterval(kruip); kruip = null; }
    if(timer){ clearTimeout(timer); timer = null; }
    if(!streep) return;
    if(stil){ streep.style.opacity = '0'; streep.style.width = '0'; return; }
    streep.style.width = '100%';
    streep.style.opacity = '0';
    setTimeout(function(){ if(streep) streep.style.width = '0'; }, 300);
  }

  function bruikbaar(a, e){
    if(!a || !a.getAttribute) return false;
    if(e.defaultPrevented) return false;
    if(e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if(a.hasAttribute('download')) return false;
    if(a.closest('[data-ddz-geen-streep]')) return false;

    var t = (a.getAttribute('target') || '').toLowerCase();
    if(t && t !== '_self') return false;

    var href = a.getAttribute('href') || '';
    if(!href || href.charAt(0) === '#') return false;
    if(/^(mailto:|tel:|javascript:|sms:)/i.test(href)) return false;

    if(a.origin && a.origin !== location.origin) return false;

    /* zelfde pagina met alleen een ander anker: geen navigatie */
    if(a.pathname === location.pathname && a.search === location.search && a.hash) return false;

    return true;
  }

  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if(!bruikbaar(a, e)) return;
    start();
  }, true);

  /* de browser toont een pagina uit zijn cache inclusief onze halve streep */
  window.addEventListener('pageshow', function(){ stop(true); });

  window.ddzLaadstreep = { start: start, stop: stop };
})();
